import { ChildrenBlock, useEditor } from '@smartfire/glue-ui/block';
import { InnerBlocks } from '@wordpress/block-editor';
import { registerBlock } from '@smartfire/glue-ui';

import styles from './block.module.scss';

const Block = () => {
    const { isEditing } = useEditor();

    return (
        <div className={styles.block}>
            {isEditing ? (
                <div className={styles.innerBlocksWrapper}>
                    <InnerBlocks allowedBlocks={['smartfire/vertical-tile']} />
                </div>
            ) : (
                <div className={styles.childrenBlockWrapper}>
                    <ChildrenBlock />
                </div>
            )}
        </div>
    );
};

export default registerBlock(
    'vertical-tiles',
    {
        Block,
        smartProps: {},
        setup: {
            title: 'Tuiles verticales',
        },
    },
    'smartfire',
);
